'use strict';

export function findNodeHandle(componentOrHandle) {
  return componentOrHandle;
}
//# sourceMappingURL=findNodeHandle.web.js.map